<template>
  <Breadcrumbs
      title="Complaints Management"
      :breadcrumbs="[
      { label: 'Complaints Management', path: '/complaints' },
    ]"
  />

  <div class="container-fluid">
      <div class="row project-cards">
          <complaintTable />
      </div>
  </div>
</template>

<script>
import complaintTable from '@/pages/complaint/complainTable.vue'
export default {
  name: 'indexList',
  components: {
      complaintTable,
  },
}
</script>
